// extracted by mini-css-extract-plugin
export default {"lastUpdated":"lastUpdated_13-_"};